import { Box, Typography } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

interface FilterToggleButtonProps<T> {
  filtersExpanded: boolean;
  setFiltersExpanded: (expanded: boolean) => void;
  filters: T;
  label?: string;
}

const FilterToggleButton = <T extends object>({
  filtersExpanded,
  setFiltersExpanded,
  filters,
  label = 'Filters',
}: FilterToggleButtonProps<T>) => {
  // Count non-undefined filter values to get active filters count
  const activeFiltersCount = Object.values(filters).filter(
    value => value !== undefined && value !== ''
  ).length;

  return (
    <Box
      sx={{
        py: 0.25,
        px: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        bgcolor: 'background.paper',
        cursor: 'pointer',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        mb: 0.5,
        height: 28,
      }}
      onClick={() => setFiltersExpanded(!filtersExpanded)}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FilterListIcon fontSize="small" sx={{ mr: 1, fontSize: '1rem' }} />
        <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
          {label} {activeFiltersCount > 0 && `(${activeFiltersCount} active)`}
        </Typography>
      </Box>
      <Box>
        {filtersExpanded ? (
          <ExpandLessIcon fontSize="small" sx={{ fontSize: '1rem' }} />
        ) : (
          <ExpandMoreIcon fontSize="small" sx={{ fontSize: '1rem' }} />
        )}
      </Box>
    </Box>
  );
};

export default FilterToggleButton;
